/* eslint-disable array-callback-return */
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import React, { useState } from 'react';
import Spinner from 'modules/common/spinner.component';
import { getSurveyQuestionTriggers, postSurveyQuestionTrigger, updateSurveyQuestionTriggers, deleteSurveyQuestionTrigger, getSurveyQuestions } from '../surveys.actions';
import { ServiceTypes, FieldTypes, ValueTypes } from './surveyQuestionConstants';
import { Box, Button, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, TextField, Tooltip, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mapSelectedTableAndService, parseRelevantFields, parseRelevantTables } from '../utils';
import { UPDATE_SURVEY_QUESTION_TRIGGER_FAILURE } from '../surveys.types';

const SurveyQuestionTriggerCard = props => {
  const { surveyQuestionTriggers, surveyQuestionId, surveyTriggerTypes, staticTriggerFields } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [triggers, setTriggers] = useState((staticTriggerFields && surveyQuestionTriggers) ? mapSelectedTableAndService(staticTriggerFields, surveyQuestionTriggers) : []);

  const isSubmitting = false;
  const isDisabled = false;
  
  const [hasChanges, setHasChanges] = useState(false);

  const services = [
    'Main Auth',
    'Candidate or Intern',
    'Destination',
    'Global',
    'HHG',
    'Homesale',
    'Temporary Living',
    'Expenses'
  ]

  const formFields = [
    {
      name: 'surveyQuestionTriggerId',
      type: 'hidden'
    },
    {
      name: 'surveyQuestionId',
      type: 'hidden'
    },
    { name: 'triggerServiceId', type: 'select', options: ServiceTypes, label: 'Service' },
    { name: 'triggerServiceId', type: 'select', options: ServiceTypes, label: 'Table' },
    { name: 'triggerFieldName', type: 'select', options: FieldTypes, label: 'Field' },
    { name: 'triggerValue', type: 'select', options: ValueTypes, label: 'Value' }

  ];

  const saveForm = async (values) => {
    setIsLoading(true);

    let mappedTriggers = [];

    triggers.map((trigger) => {
        mappedTriggers.push({
            surveyTriggerId: trigger.surveyTriggerId ? trigger.surveyTriggerId : undefined,
            surveyQuestionId: surveyQuestionId,
            serviceFieldId: trigger.serviceFieldId,
            triggerTypeId: trigger.triggerTypeId,
            matchValue: trigger.matchValue,
            addedBy: trigger.addedBy,
            addedOn: trigger.addedOn,
            modifiedBy: trigger.modifiedBy,
            modifiedOn: new Date()
        });
    });

    const updateTriggersResp = await props.updateSurveyQuestionTriggers(surveyQuestionId, mappedTriggers);
    if (updateTriggersResp.type === UPDATE_SURVEY_QUESTION_TRIGGER_FAILURE) {
        props.showToast('Failed to update triggers, please try again later', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
       await props.getSurveyQuestions();
        props.showToast('Triggers updated successfully', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
    }

    setIsLoading(false);
    setHasChanges(false);
  };

  const setTriggerValue = (value, trigger, inputName) => {
    let updatedTriggers = [...triggers];
    const index = updatedTriggers.findIndex((ut) => ut.surveyTriggerId ? (ut.surveyTriggerId === trigger.surveyTriggerId) : (ut.tempId === trigger.tempId));
    updatedTriggers[index][inputName] = value;
    setTriggers(updatedTriggers);
    setHasChanges(true);
  }

  const addTrigger = () => {
    let updatedTriggers = [...triggers];
    updatedTriggers.push({tempId: (Math.random() * 1000), selectedService: null, selectedTable: null, serviceFieldId: null, triggerTypeId: null, matchValue: '', addedBy: 1, addedOn: new Date(), modifiedBy: 1, modifiedOn: new Date()}); // TODO: Replace addedBy and modifiedBy with current user
    setTriggers(updatedTriggers);
    setHasChanges(true);
  }

  const deleteTrigger = (trigger) => {
    let updatedTriggers = [...triggers];
    updatedTriggers = updatedTriggers.filter((ut) => ut.surveyTriggerId !== trigger.surveyTriggerId);
    setTriggers(updatedTriggers);
    setHasChanges(true);
  }

  return (
    <>
      {isLoading && <Spinner />}
      {!isLoading && (
          <Grid item xs={12}>
              <Paper className="card-root" style={{ padding: '16px' }}>
                <Grid container item alignItems="center" justifyContent="space-between" style={{ marginBottom: '16px' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    
                    <Tooltip title={'Question-Enabling Trigger Setup'} placement="right">
                      <FontAwesomeIcon icon={['fas', 'flag']} size="2x" />
                    </Tooltip>
                    
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '20px',
                        paddingLeft: '20px'
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontSize: '1.3125rem',
                          fontWeight: 'bold'
                        }}
                      >
                        Question-Enabling Trigger Setup
                      </Typography>
                    </Box>
                  </Box>
                  <Button disabled={isSubmitting} onClick={addTrigger}>
                    Add New Trigger
                  </Button>
                </Grid>
                {triggers && triggers.map((trigger) => {
                  const visibleFields = formFields.filter(field => field.type !== 'hidden');
                  const fieldCount = visibleFields.length;
                  const xsValue = Math.floor(12 / fieldCount) - 1; // Leave space for trashcan icon
        
                  return (
                    <Grid container alignItems="center" spacing={2} style={{ marginBottom: '8px' }}>
                        <Grid item xs={xsValue}>
                          <FormControl fullWidth margin="dense">
                            <InputLabel>Service</InputLabel>
                            <Select
                              value={trigger.selectedService}
                              onChange={e => setTriggerValue(e.target.value, trigger, 'selectedService')}
                              disabled={isSubmitting || isDisabled}
                            >
                              {services.map(option => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={xsValue}>
                          <FormControl fullWidth margin="dense">
                            <InputLabel>Table</InputLabel>
                            <Select
                              value={trigger.selectedTable}
                              onChange={e => setTriggerValue(e.target.value, trigger, 'selectedTable')}
                              disabled={isSubmitting || isDisabled}
                            >
                              {parseRelevantTables(staticTriggerFields, trigger.selectedService).map(option => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={xsValue}>
                          <FormControl fullWidth margin="dense">
                            <InputLabel>Field</InputLabel>
                            <Select
                              value={trigger.serviceFieldId}
                              onChange={e => setTriggerValue(e.target.value, trigger, 'serviceFieldId')}
                              disabled={isSubmitting || isDisabled}
                            >
                              {parseRelevantFields(staticTriggerFields, trigger.selectedTable).map(option => (
                                <MenuItem key={option.triggerServiceId} value={option.triggerServiceId}>
                                  {option.fieldDisplayName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={xsValue}>
                          <FormControl fullWidth margin="dense">
                            <InputLabel>Value</InputLabel>
                            <Select
                              value={trigger.triggerTypeId}
                              onChange={e => setTriggerValue(e.target.value, trigger, 'triggerTypeId')}
                              disabled={isSubmitting || isDisabled}
                            >
                              {surveyTriggerTypes.map(option => (
                                <MenuItem key={option.id} value={option.id}>
                                  {option.title}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>

                        {(trigger.triggerTypeId === '98ba1156-a956-45db-9d68-10f2e345b7f9' || trigger.triggerTypeId === '6b8ec837-01c9-4773-ad3c-0e6c41263678' || trigger.triggerTypeId === 'e78add1f-2d1c-4241-b15b-2a7dcf12657d' || trigger.triggerTypeId === '01a99433-8b24-4ac8-a004-7e9c8e17c3a0') && (
                          <Grid item xs={xsValue}>
                            <TextField
                              label={'Match Value'}
                              value={trigger.matchValue}
                              onChange={e => setTriggerValue(e.target.value, trigger, 'matchValue')}
                              disabled={isSubmitting || isDisabled}
                              fullWidth
                              margin="dense"
                            />
                          </Grid>
                        )}

                        <Grid item xs="auto">
                          <IconButton onClick={() => deleteTrigger(trigger)} disabled={isSubmitting || isDisabled}>
                            <FontAwesomeIcon icon={['far', 'trash-alt']} size="lg" />
                          </IconButton>
                        </Grid>
                    </Grid>
                  )

                })}
                <Grid container justifyContent="flex-end" style={{ marginTop: '1rem' }}>
                  <Button
                    color="secondary"
                    variant="contained"
                    sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                    onClick={saveForm}
                    disabled={!hasChanges || isLoading || isDisabled}
                  >
                    Save
                  </Button>
                </Grid>
              </Paper>
            </Grid>
      )}
    </>
  );
};

const mapStateToProps = state => {
    const { staticTriggerFields } = state.surveys;
    const { surveyTriggerTypes } = state.enumerations.allEnums;
    return {
      staticTriggerFields: staticTriggerFields,
      surveyTriggerTypes: surveyTriggerTypes
    };
  };

export default compose(
  connect(mapStateToProps, {
    showToast,
    getSurveyQuestionTriggers,
    postSurveyQuestionTrigger,
    updateSurveyQuestionTriggers,
    deleteSurveyQuestionTrigger,
    getSurveyQuestions
  })
)(SurveyQuestionTriggerCard);
